<template>
    <div>
        <div class="info-box">
            <courseinfo ref="courseinfo" :intoType='intoType' :intoCourseId='this.$route.query.courseId'></courseinfo>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>平行班考试信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p>是否统一试卷：</p>
                    <div class="radio">
                        <a-radio-group :default-value="1" v-model="info.tysj" @change="onChange" :disabled="infoDisabled">
                            <a-radio :value=true>
                                是
                            </a-radio>
                            <a-radio :value=false>
                                否
                            </a-radio>
                        </a-radio-group>
                    </div>
                </div>
                <div class="input-box input-box-center" v-show="!info.tysj">
                    <p>说明原因：</p>
                    <a-textarea class="input" :rows="4" :disabled="infoDisabled" v-model="info.yy" />
                </div>
            </div>
        </div>
        <div class="info-box" v-show="source=='list'">
            <div class="info-title">
                <h3>审批意见</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box input-box-center">
                    <p>意见：</p>
                    <a-textarea class="input" v-model="info.spyj" :rows="4" :disabled="type!='approve'"/>
                </div>
            </div>
        </div>
        <div class="btn-box" v-if="type !='approve'">
            <a-button type="primary" v-if="type=='edit'||type=='add'" @click="sub">提交</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
        <div class="btn-box" v-if="type=='approve'">
            <a-button type="primary"  @click="approveClick('approved')">同意</a-button>
            <a-button type="primary"  @click="approveClick('reject')">驳回</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { add,update,info,approve } from '@/baseAPI/undergraduate/culture/parallelClass'
    import courseinfo from './courseInfo'
    export default {
        name: '',
        components: {
            courseinfo
        },
        data () {
            return {
                type:'',
                info:{
                    approvalStatus: '',
	                kcbId: '',
	                tysj: true,
	                yy: ''
                },
                intoType:'into',
                intoCourseId:'',
                source:'',
                createBy:'',
                infoDisabled:false,
                
            }
        },
        mounted () {
            this.type=this.$route.query.type;
            this.source=this.$route.query.source;   
            if(this.type=='add'){
                info(this.$route.query.courseId).then(res=>{
                    this.info.kcbId=this.$route.query.courseId;
                })
            }else{
                setTimeout(()=>{
                    info(this.$route.query.courseId).then(res=>{
                        this.info=res.data;
                    })
                },500)
            }

            if(this.type=='approve'||this.type=='look'){
                this.infoDisabled = true
            }

        },
        methods:{
            onChange(e){
                this.info.tysj = e.target.value
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            approveClick(state){
                this.info.approvalStatus=state
                approve(this.info).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'平行班考试'+(state=='approved'?'审批通过':'驳回成功'),
                        });
                        this.$router.go(-1)
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })

            },
            sub(){
                var isSub=true;
                var arr=['kcbId']
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                if(isSub){
                    if(this.type=='add'){
                        this.info.approvalStatus = 'commit'
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增平行班考试成功，请联系系主任审批！',
                                    duration: 0,
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改平行班考试成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .radio{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .standard{
        width: 28px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 200px;
        text-align: center;
        border-radius: 6px 0 0 6px !important;
        z-index: 0;
        pointer-events: auto;
        cursor: pointer;
        color: rgb(255, 255, 255);
        background-color: #245086;
        opacity: 0.8;
        padding: 2px 0px 0px 0px;
    }

    .standard:hover{
        opacity: 1;
    }

    .info-main .input-maxbox{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-maxbox p{
        width: 10rem;
        text-align: right;
    }

    .info-main .input-maxbox .textarea{
        width: calc(100% - 10rem);
    }

    .info-main .input-notes{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-notes .notes{
        width: calc(100% - 10rem);
        text-align: left;
        font-size: 0.9rem;
    }

    .info-main .input-notes .note-title{
        width: 10rem;
        text-align: right;
        font-size: 0.9rem;
        font-weight: bolder;
        color: black;
    }

</style>
